const actionName = {
    nameEn: '',
    nameDe: '',
};

export const formInitialValues = {
    actionName,
};
